export const AccessLevel = {
    "member": "member",
    "paid": "paid",
    "public": "public"
};

export const AllCoursesPageOrderByInput = {
    "createdAt_ASC": "createdAt_ASC",
    "createdAt_DESC": "createdAt_DESC",
    "id_ASC": "id_ASC",
    "id_DESC": "id_DESC",
    "publishedAt_ASC": "publishedAt_ASC",
    "publishedAt_DESC": "publishedAt_DESC",
    "slug_ASC": "slug_ASC",
    "slug_DESC": "slug_DESC",
    "updatedAt_ASC": "updatedAt_ASC",
    "updatedAt_DESC": "updatedAt_DESC"
};

export const AssetOrderByInput = {
    "createdAt_ASC": "createdAt_ASC",
    "createdAt_DESC": "createdAt_DESC",
    "fileName_ASC": "fileName_ASC",
    "fileName_DESC": "fileName_DESC",
    "handle_ASC": "handle_ASC",
    "handle_DESC": "handle_DESC",
    "height_ASC": "height_ASC",
    "height_DESC": "height_DESC",
    "id_ASC": "id_ASC",
    "id_DESC": "id_DESC",
    "mimeType_ASC": "mimeType_ASC",
    "mimeType_DESC": "mimeType_DESC",
    "publishedAt_ASC": "publishedAt_ASC",
    "publishedAt_DESC": "publishedAt_DESC",
    "size_ASC": "size_ASC",
    "size_DESC": "size_DESC",
    "updatedAt_ASC": "updatedAt_ASC",
    "updatedAt_DESC": "updatedAt_DESC",
    "width_ASC": "width_ASC",
    "width_DESC": "width_DESC"
};

export const AudienceOrderByInput = {
    "createdAt_ASC": "createdAt_ASC",
    "createdAt_DESC": "createdAt_DESC",
    "description_ASC": "description_ASC",
    "description_DESC": "description_DESC",
    "icon_ASC": "icon_ASC",
    "icon_DESC": "icon_DESC",
    "id_ASC": "id_ASC",
    "id_DESC": "id_DESC",
    "name_ASC": "name_ASC",
    "name_DESC": "name_DESC",
    "publishedAt_ASC": "publishedAt_ASC",
    "publishedAt_DESC": "publishedAt_DESC",
    "updatedAt_ASC": "updatedAt_ASC",
    "updatedAt_DESC": "updatedAt_DESC"
};

export const CategoryOrderByInput = {
    "createdAt_ASC": "createdAt_ASC",
    "createdAt_DESC": "createdAt_DESC",
    "id_ASC": "id_ASC",
    "id_DESC": "id_DESC",
    "name_ASC": "name_ASC",
    "name_DESC": "name_DESC",
    "publishedAt_ASC": "publishedAt_ASC",
    "publishedAt_DESC": "publishedAt_DESC",
    "slug_ASC": "slug_ASC",
    "slug_DESC": "slug_DESC",
    "updatedAt_ASC": "updatedAt_ASC",
    "updatedAt_DESC": "updatedAt_DESC"
};

export const ConfigurationOrderByInput = {
    "createdAt_ASC": "createdAt_ASC",
    "createdAt_DESC": "createdAt_DESC",
    "customer_ASC": "customer_ASC",
    "customer_DESC": "customer_DESC",
    "id_ASC": "id_ASC",
    "id_DESC": "id_DESC",
    "logoLink_ASC": "logoLink_ASC",
    "logoLink_DESC": "logoLink_DESC",
    "publishedAt_ASC": "publishedAt_ASC",
    "publishedAt_DESC": "publishedAt_DESC",
    "title_ASC": "title_ASC",
    "title_DESC": "title_DESC",
    "updatedAt_ASC": "updatedAt_ASC",
    "updatedAt_DESC": "updatedAt_DESC"
};

export const CourseOrderByInput = {
    "createdAt_ASC": "createdAt_ASC",
    "createdAt_DESC": "createdAt_DESC",
    "customer_ASC": "customer_ASC",
    "customer_DESC": "customer_DESC",
    "id_ASC": "id_ASC",
    "id_DESC": "id_DESC",
    "isUsedForSales_ASC": "isUsedForSales_ASC",
    "isUsedForSales_DESC": "isUsedForSales_DESC",
    "keyTakeaways_ASC": "keyTakeaways_ASC",
    "keyTakeaways_DESC": "keyTakeaways_DESC",
    "name_ASC": "name_ASC",
    "name_DESC": "name_DESC",
    "outline_ASC": "outline_ASC",
    "outline_DESC": "outline_DESC",
    "publishedAt_ASC": "publishedAt_ASC",
    "publishedAt_DESC": "publishedAt_DESC",
    "publishedDate_ASC": "publishedDate_ASC",
    "publishedDate_DESC": "publishedDate_DESC",
    "shortDescription_ASC": "shortDescription_ASC",
    "shortDescription_DESC": "shortDescription_DESC",
    "skillLevel_ASC": "skillLevel_ASC",
    "skillLevel_DESC": "skillLevel_DESC",
    "slug_ASC": "slug_ASC",
    "slug_DESC": "slug_DESC",
    "timeToComplete_ASC": "timeToComplete_ASC",
    "timeToComplete_DESC": "timeToComplete_DESC",
    "updatedAt_ASC": "updatedAt_ASC",
    "updatedAt_DESC": "updatedAt_DESC"
};

export const CtaSplitSectionOrderByInput = {
    "id_ASC": "id_ASC",
    "id_DESC": "id_DESC",
    "leftDescription_ASC": "leftDescription_ASC",
    "leftDescription_DESC": "leftDescription_DESC",
    "leftTitle_ASC": "leftTitle_ASC",
    "leftTitle_DESC": "leftTitle_DESC",
    "rightDescription_ASC": "rightDescription_ASC",
    "rightDescription_DESC": "rightDescription_DESC",
    "rightTitle_ASC": "rightTitle_ASC",
    "rightTitle_DESC": "rightTitle_DESC"
};

export const Customer = {
    "Avo": "Avo",
    "Deepskydata": "Deepskydata",
    "Keboola": "Keboola",
    "PiwikPro": "PiwikPro"
};

export const DocumentFileTypes = {
    "doc": "doc",
    "docx": "docx",
    "html": "html",
    "jpg": "jpg",
    "odp": "odp",
    "ods": "ods",
    "odt": "odt",
    "pdf": "pdf",
    "png": "png",
    "ppt": "ppt",
    "pptx": "pptx",
    "svg": "svg",
    "txt": "txt",
    "webp": "webp",
    "xls": "xls",
    "xlsx": "xlsx"
};

export const EntityTypeName = {
    "AllCoursesPage": "AllCoursesPage",
    "Asset": "Asset",
    "Audience": "Audience",
    "Category": "Category",
    "Configuration": "Configuration",
    "Course": "Course",
    "CtaSplitSection": "CtaSplitSection",
    "Hero": "Hero",
    "HomePage": "HomePage",
    "ImagesGrid": "ImagesGrid",
    "Incentive": "Incentive",
    "InfoCard": "InfoCard",
    "Instructor": "Instructor",
    "LearningPath": "LearningPath",
    "LegalPage": "LegalPage",
    "Lesson": "Lesson",
    "Link": "Link",
    "Package": "Package",
    "Page": "Page",
    "Platform": "Platform",
    "PlatformLink": "PlatformLink",
    "Prerequisite": "Prerequisite",
    "PricePackage": "PricePackage",
    "Product": "Product",
    "Reason": "Reason",
    "ResponsiveImage": "ResponsiveImage",
    "ScheduledOperation": "ScheduledOperation",
    "ScheduledRelease": "ScheduledRelease",
    "SectionHeader": "SectionHeader",
    "Seo": "Seo",
    "ShowcaseSlider": "ShowcaseSlider",
    "ShowcaseSliderEntry": "ShowcaseSliderEntry",
    "Tag": "Tag",
    "TeachersInfoCard": "TeachersInfoCard",
    "Testimonial": "Testimonial",
    "UsecasemarketingPage": "UsecasemarketingPage",
    "User": "User",
    "VideoList": "VideoList",
    "YoutubeVideo": "YoutubeVideo"
};

export const HeroOrderByInput = {
    "heading_ASC": "heading_ASC",
    "heading_DESC": "heading_DESC",
    "id_ASC": "id_ASC",
    "id_DESC": "id_DESC",
    "secondaryHeading_ASC": "secondaryHeading_ASC",
    "secondaryHeading_DESC": "secondaryHeading_DESC",
    "slug_ASC": "slug_ASC",
    "slug_DESC": "slug_DESC"
};

export const HomePageOrderByInput = {
    "createdAt_ASC": "createdAt_ASC",
    "createdAt_DESC": "createdAt_DESC",
    "id_ASC": "id_ASC",
    "id_DESC": "id_DESC",
    "publishedAt_ASC": "publishedAt_ASC",
    "publishedAt_DESC": "publishedAt_DESC",
    "updatedAt_ASC": "updatedAt_ASC",
    "updatedAt_DESC": "updatedAt_DESC"
};

export const Icons = {
    "ArrowIcon": "ArrowIcon",
    "ArrowLeftIcon": "ArrowLeftIcon",
    "ArrowRightIcon": "ArrowRightIcon",
    "CheckMarkCircleIcon": "CheckMarkCircleIcon",
    "ChevronDownIcon": "ChevronDownIcon",
    "ChevronRightIcon": "ChevronRightIcon",
    "ChevronUpIcon": "ChevronUpIcon",
    "CinemaModeOnIcon": "CinemaModeOnIcon",
    "CloseIcon": "CloseIcon",
    "FullscreenOffIcon": "FullscreenOffIcon",
    "FullscreenOnIcon": "FullscreenOnIcon",
    "GoogleSignInIcon": "GoogleSignInIcon",
    "HandIcon": "HandIcon",
    "HeartIcon": "HeartIcon",
    "LeftArrowIcon": "LeftArrowIcon",
    "LineIcon": "LineIcon",
    "LinkedInSignInIcon": "LinkedInSignInIcon",
    "LogoWhite": "LogoWhite",
    "MailSignInIcon": "MailSignInIcon",
    "PauseIcon": "PauseIcon",
    "PlayIcon": "PlayIcon",
    "ReplayIcon": "ReplayIcon",
    "RightIcon": "RightIcon",
    "SparklesIcon": "SparklesIcon",
    "SpeachBubbleIcon": "SpeachBubbleIcon",
    "UserIcon": "UserIcon",
    "UserOffIcon": "UserOffIcon",
    "certificateIcon": "certificateIcon",
    "checkMarkIcon": "checkMarkIcon",
    "chevronDoubleRight": "chevronDoubleRight",
    "prerequisitesIcon": "prerequisitesIcon",
    "skillLevelIconHigh": "skillLevelIconHigh",
    "skillLevelIconLow": "skillLevelIconLow",
    "skillLevelIconMedium": "skillLevelIconMedium",
    "soundOffIcon": "soundOffIcon",
    "soundOnIcon": "soundOnIcon",
    "timeToCompleteIcon": "timeToCompleteIcon"
};

export const ImageFit = {
    "clip": "clip",
    "crop": "crop",
    "max": "max",
    "scale": "scale"
};

export const ImagesGridOrderByInput = {
    "createdAt_ASC": "createdAt_ASC",
    "createdAt_DESC": "createdAt_DESC",
    "id_ASC": "id_ASC",
    "id_DESC": "id_DESC",
    "publishedAt_ASC": "publishedAt_ASC",
    "publishedAt_DESC": "publishedAt_DESC",
    "updatedAt_ASC": "updatedAt_ASC",
    "updatedAt_DESC": "updatedAt_DESC"
};

export const IncentiveOrderByInput = {
    "benefitsTitle_ASC": "benefitsTitle_ASC",
    "benefitsTitle_DESC": "benefitsTitle_DESC",
    "benefits_ASC": "benefits_ASC",
    "benefits_DESC": "benefits_DESC",
    "createdAt_ASC": "createdAt_ASC",
    "createdAt_DESC": "createdAt_DESC",
    "id_ASC": "id_ASC",
    "id_DESC": "id_DESC",
    "name_ASC": "name_ASC",
    "name_DESC": "name_DESC",
    "publishedAt_ASC": "publishedAt_ASC",
    "publishedAt_DESC": "publishedAt_DESC",
    "shortDescription_ASC": "shortDescription_ASC",
    "shortDescription_DESC": "shortDescription_DESC",
    "slug_ASC": "slug_ASC",
    "slug_DESC": "slug_DESC",
    "updatedAt_ASC": "updatedAt_ASC",
    "updatedAt_DESC": "updatedAt_DESC"
};

export const InfoCardOrderByInput = {
    "description_ASC": "description_ASC",
    "description_DESC": "description_DESC",
    "iconName_ASC": "iconName_ASC",
    "iconName_DESC": "iconName_DESC",
    "id_ASC": "id_ASC",
    "id_DESC": "id_DESC",
    "title_ASC": "title_ASC",
    "title_DESC": "title_DESC"
};

export const InstructorOrderByInput = {
    "company_ASC": "company_ASC",
    "company_DESC": "company_DESC",
    "createdAt_ASC": "createdAt_ASC",
    "createdAt_DESC": "createdAt_DESC",
    "description_ASC": "description_ASC",
    "description_DESC": "description_DESC",
    "eMail_ASC": "eMail_ASC",
    "eMail_DESC": "eMail_DESC",
    "id_ASC": "id_ASC",
    "id_DESC": "id_DESC",
    "jobTitle_ASC": "jobTitle_ASC",
    "jobTitle_DESC": "jobTitle_DESC",
    "linkedInUrl_ASC": "linkedInUrl_ASC",
    "linkedInUrl_DESC": "linkedInUrl_DESC",
    "name_ASC": "name_ASC",
    "name_DESC": "name_DESC",
    "publishedAt_ASC": "publishedAt_ASC",
    "publishedAt_DESC": "publishedAt_DESC",
    "twitterUrl_ASC": "twitterUrl_ASC",
    "twitterUrl_DESC": "twitterUrl_DESC",
    "updatedAt_ASC": "updatedAt_ASC",
    "updatedAt_DESC": "updatedAt_DESC",
    "youtubeUrl_ASC": "youtubeUrl_ASC",
    "youtubeUrl_DESC": "youtubeUrl_DESC"
};

export const LearningPathOrderByInput = {
    "createdAt_ASC": "createdAt_ASC",
    "createdAt_DESC": "createdAt_DESC",
    "description_ASC": "description_ASC",
    "description_DESC": "description_DESC",
    "highlights_ASC": "highlights_ASC",
    "highlights_DESC": "highlights_DESC",
    "id_ASC": "id_ASC",
    "id_DESC": "id_DESC",
    "index_ASC": "index_ASC",
    "index_DESC": "index_DESC",
    "publishedAt_ASC": "publishedAt_ASC",
    "publishedAt_DESC": "publishedAt_DESC",
    "shortDescription_ASC": "shortDescription_ASC",
    "shortDescription_DESC": "shortDescription_DESC",
    "skillLevel_ASC": "skillLevel_ASC",
    "skillLevel_DESC": "skillLevel_DESC",
    "slug_ASC": "slug_ASC",
    "slug_DESC": "slug_DESC",
    "timeToComplete_ASC": "timeToComplete_ASC",
    "timeToComplete_DESC": "timeToComplete_DESC",
    "title_ASC": "title_ASC",
    "title_DESC": "title_DESC",
    "updatedAt_ASC": "updatedAt_ASC",
    "updatedAt_DESC": "updatedAt_DESC"
};

export const LegalPageOrderByInput = {
    "createdAt_ASC": "createdAt_ASC",
    "createdAt_DESC": "createdAt_DESC",
    "id_ASC": "id_ASC",
    "id_DESC": "id_DESC",
    "publishedAt_ASC": "publishedAt_ASC",
    "publishedAt_DESC": "publishedAt_DESC",
    "slug_ASC": "slug_ASC",
    "slug_DESC": "slug_DESC",
    "title_ASC": "title_ASC",
    "title_DESC": "title_DESC",
    "updatedAt_ASC": "updatedAt_ASC",
    "updatedAt_DESC": "updatedAt_DESC"
};

export const LessonOrderByInput = {
    "accessLevel_ASC": "accessLevel_ASC",
    "accessLevel_DESC": "accessLevel_DESC",
    "createdAt_ASC": "createdAt_ASC",
    "createdAt_DESC": "createdAt_DESC",
    "description_ASC": "description_ASC",
    "description_DESC": "description_DESC",
    "dropboxLink_ASC": "dropboxLink_ASC",
    "dropboxLink_DESC": "dropboxLink_DESC",
    "duration_ASC": "duration_ASC",
    "duration_DESC": "duration_DESC",
    "finishedCourse_ASC": "finishedCourse_ASC",
    "finishedCourse_DESC": "finishedCourse_DESC",
    "furtherReading_ASC": "furtherReading_ASC",
    "furtherReading_DESC": "furtherReading_DESC",
    "highlights_ASC": "highlights_ASC",
    "highlights_DESC": "highlights_DESC",
    "id_ASC": "id_ASC",
    "id_DESC": "id_DESC",
    "keyTakeAway_ASC": "keyTakeAway_ASC",
    "keyTakeAway_DESC": "keyTakeAway_DESC",
    "name_ASC": "name_ASC",
    "name_DESC": "name_DESC",
    "publishedAt_ASC": "publishedAt_ASC",
    "publishedAt_DESC": "publishedAt_DESC",
    "slug_ASC": "slug_ASC",
    "slug_DESC": "slug_DESC",
    "startedCourse_ASC": "startedCourse_ASC",
    "startedCourse_DESC": "startedCourse_DESC",
    "streamUrl_ASC": "streamUrl_ASC",
    "streamUrl_DESC": "streamUrl_DESC",
    "summary_ASC": "summary_ASC",
    "summary_DESC": "summary_DESC",
    "transcript_ASC": "transcript_ASC",
    "transcript_DESC": "transcript_DESC",
    "updatedAt_ASC": "updatedAt_ASC",
    "updatedAt_DESC": "updatedAt_DESC",
    "videoUrl_ASC": "videoUrl_ASC",
    "videoUrl_DESC": "videoUrl_DESC"
};

export const LinkOrderByInput = {
    "class_ASC": "class_ASC",
    "class_DESC": "class_DESC",
    "id_ASC": "id_ASC",
    "id_DESC": "id_DESC",
    "text_ASC": "text_ASC",
    "text_DESC": "text_DESC",
    "url_ASC": "url_ASC",
    "url_DESC": "url_DESC"
};

export const Locale = {
    "en": "en"
};

export const PackageOrderByInput = {
    "createdAt_ASC": "createdAt_ASC",
    "createdAt_DESC": "createdAt_DESC",
    "id_ASC": "id_ASC",
    "id_DESC": "id_DESC",
    "marketingTitle_ASC": "marketingTitle_ASC",
    "marketingTitle_DESC": "marketingTitle_DESC",
    "packageTitle_ASC": "packageTitle_ASC",
    "packageTitle_DESC": "packageTitle_DESC",
    "publishedAt_ASC": "publishedAt_ASC",
    "publishedAt_DESC": "publishedAt_DESC",
    "slug_ASC": "slug_ASC",
    "slug_DESC": "slug_DESC",
    "updatedAt_ASC": "updatedAt_ASC",
    "updatedAt_DESC": "updatedAt_DESC"
};

export const PageOrderByInput = {
    "createdAt_ASC": "createdAt_ASC",
    "createdAt_DESC": "createdAt_DESC",
    "id_ASC": "id_ASC",
    "id_DESC": "id_DESC",
    "name_ASC": "name_ASC",
    "name_DESC": "name_DESC",
    "publishedAt_ASC": "publishedAt_ASC",
    "publishedAt_DESC": "publishedAt_DESC",
    "updatedAt_ASC": "updatedAt_ASC",
    "updatedAt_DESC": "updatedAt_DESC",
    "url_ASC": "url_ASC",
    "url_DESC": "url_DESC"
};

export const PlatformLinkOrderByInput = {
    "id_ASC": "id_ASC",
    "id_DESC": "id_DESC",
    "textContent_ASC": "textContent_ASC",
    "textContent_DESC": "textContent_DESC",
    "url_ASC": "url_ASC",
    "url_DESC": "url_DESC"
};

export const PlatformOrderByInput = {
    "createdAt_ASC": "createdAt_ASC",
    "createdAt_DESC": "createdAt_DESC",
    "description_ASC": "description_ASC",
    "description_DESC": "description_DESC",
    "id_ASC": "id_ASC",
    "id_DESC": "id_DESC",
    "name_ASC": "name_ASC",
    "name_DESC": "name_DESC",
    "publishedAt_ASC": "publishedAt_ASC",
    "publishedAt_DESC": "publishedAt_DESC",
    "slug_ASC": "slug_ASC",
    "slug_DESC": "slug_DESC",
    "updatedAt_ASC": "updatedAt_ASC",
    "updatedAt_DESC": "updatedAt_DESC"
};

export const PrerequisiteOrderByInput = {
    "createdAt_ASC": "createdAt_ASC",
    "createdAt_DESC": "createdAt_DESC",
    "id_ASC": "id_ASC",
    "id_DESC": "id_DESC",
    "publishedAt_ASC": "publishedAt_ASC",
    "publishedAt_DESC": "publishedAt_DESC",
    "shortDescription_ASC": "shortDescription_ASC",
    "shortDescription_DESC": "shortDescription_DESC",
    "title_ASC": "title_ASC",
    "title_DESC": "title_DESC",
    "updatedAt_ASC": "updatedAt_ASC",
    "updatedAt_DESC": "updatedAt_DESC"
};

export const PricePackageOrderByInput = {
    "createdAt_ASC": "createdAt_ASC",
    "createdAt_DESC": "createdAt_DESC",
    "deliveryTime_ASC": "deliveryTime_ASC",
    "deliveryTime_DESC": "deliveryTime_DESC",
    "id_ASC": "id_ASC",
    "id_DESC": "id_DESC",
    "label_ASC": "label_ASC",
    "label_DESC": "label_DESC",
    "name_ASC": "name_ASC",
    "name_DESC": "name_DESC",
    "price_ASC": "price_ASC",
    "price_DESC": "price_DESC",
    "publishedAt_ASC": "publishedAt_ASC",
    "publishedAt_DESC": "publishedAt_DESC",
    "updatedAt_ASC": "updatedAt_ASC",
    "updatedAt_DESC": "updatedAt_DESC"
};

export const ProductOrderByInput = {
    "basePrice_ASC": "basePrice_ASC",
    "basePrice_DESC": "basePrice_DESC",
    "createdAt_ASC": "createdAt_ASC",
    "createdAt_DESC": "createdAt_DESC",
    "deliverables_ASC": "deliverables_ASC",
    "deliverables_DESC": "deliverables_DESC",
    "emailTexts_ASC": "emailTexts_ASC",
    "emailTexts_DESC": "emailTexts_DESC",
    "id_ASC": "id_ASC",
    "id_DESC": "id_DESC",
    "name_ASC": "name_ASC",
    "name_DESC": "name_DESC",
    "publishedAt_ASC": "publishedAt_ASC",
    "publishedAt_DESC": "publishedAt_DESC",
    "short_ASC": "short_ASC",
    "short_DESC": "short_DESC",
    "updatedAt_ASC": "updatedAt_ASC",
    "updatedAt_DESC": "updatedAt_DESC"
};

export const ReasonOrderByInput = {
    "createdAt_ASC": "createdAt_ASC",
    "createdAt_DESC": "createdAt_DESC",
    "description_ASC": "description_ASC",
    "description_DESC": "description_DESC",
    "id_ASC": "id_ASC",
    "id_DESC": "id_DESC",
    "name_ASC": "name_ASC",
    "name_DESC": "name_DESC",
    "publishedAt_ASC": "publishedAt_ASC",
    "publishedAt_DESC": "publishedAt_DESC",
    "updatedAt_ASC": "updatedAt_ASC",
    "updatedAt_DESC": "updatedAt_DESC"
};

export const ResponsiveImageOrderByInput = {
    "altText_ASC": "altText_ASC",
    "altText_DESC": "altText_DESC",
    "id_ASC": "id_ASC",
    "id_DESC": "id_DESC"
};

export const RobotsOptions = {
    "all": "all",
    "nofollow": "nofollow",
    "noindex": "noindex",
    "none": "none"
};

export const ScheduledOperationOrderByInput = {
    "createdAt_ASC": "createdAt_ASC",
    "createdAt_DESC": "createdAt_DESC",
    "description_ASC": "description_ASC",
    "description_DESC": "description_DESC",
    "errorMessage_ASC": "errorMessage_ASC",
    "errorMessage_DESC": "errorMessage_DESC",
    "id_ASC": "id_ASC",
    "id_DESC": "id_DESC",
    "publishedAt_ASC": "publishedAt_ASC",
    "publishedAt_DESC": "publishedAt_DESC",
    "status_ASC": "status_ASC",
    "status_DESC": "status_DESC",
    "updatedAt_ASC": "updatedAt_ASC",
    "updatedAt_DESC": "updatedAt_DESC"
};

export const ScheduledOperationStatus = {
    "CANCELED": "CANCELED",
    "COMPLETED": "COMPLETED",
    "FAILED": "FAILED",
    "IN_PROGRESS": "IN_PROGRESS",
    "PENDING": "PENDING"
};

export const ScheduledReleaseOrderByInput = {
    "createdAt_ASC": "createdAt_ASC",
    "createdAt_DESC": "createdAt_DESC",
    "description_ASC": "description_ASC",
    "description_DESC": "description_DESC",
    "errorMessage_ASC": "errorMessage_ASC",
    "errorMessage_DESC": "errorMessage_DESC",
    "id_ASC": "id_ASC",
    "id_DESC": "id_DESC",
    "isActive_ASC": "isActive_ASC",
    "isActive_DESC": "isActive_DESC",
    "isImplicit_ASC": "isImplicit_ASC",
    "isImplicit_DESC": "isImplicit_DESC",
    "publishedAt_ASC": "publishedAt_ASC",
    "publishedAt_DESC": "publishedAt_DESC",
    "releaseAt_ASC": "releaseAt_ASC",
    "releaseAt_DESC": "releaseAt_DESC",
    "status_ASC": "status_ASC",
    "status_DESC": "status_DESC",
    "title_ASC": "title_ASC",
    "title_DESC": "title_DESC",
    "updatedAt_ASC": "updatedAt_ASC",
    "updatedAt_DESC": "updatedAt_DESC"
};

export const ScheduledReleaseStatus = {
    "COMPLETED": "COMPLETED",
    "FAILED": "FAILED",
    "IN_PROGRESS": "IN_PROGRESS",
    "PENDING": "PENDING"
};

export const SectionHeaderOrderByInput = {
    "description_ASC": "description_ASC",
    "description_DESC": "description_DESC",
    "headline_ASC": "headline_ASC",
    "headline_DESC": "headline_DESC",
    "id_ASC": "id_ASC",
    "id_DESC": "id_DESC"
};

export const SeoOrderByInput = {
    "id_ASC": "id_ASC",
    "id_DESC": "id_DESC",
    "metaDescription_ASC": "metaDescription_ASC",
    "metaDescription_DESC": "metaDescription_DESC",
    "metaTitle_ASC": "metaTitle_ASC",
    "metaTitle_DESC": "metaTitle_DESC",
    "ogDescription_ASC": "ogDescription_ASC",
    "ogDescription_DESC": "ogDescription_DESC",
    "ogTitle_ASC": "ogTitle_ASC",
    "ogTitle_DESC": "ogTitle_DESC",
    "robots_ASC": "robots_ASC",
    "robots_DESC": "robots_DESC"
};

export const ShowcaseSliderEntryOrderByInput = {
    "id_ASC": "id_ASC",
    "id_DESC": "id_DESC",
    "title_ASC": "title_ASC",
    "title_DESC": "title_DESC",
    "videoUrl_ASC": "videoUrl_ASC",
    "videoUrl_DESC": "videoUrl_DESC"
};

export const ShowcaseSliderOrderByInput = {
    "id_ASC": "id_ASC",
    "id_DESC": "id_DESC"
};

export const SkillLevel = {
    "Advanced": "Advanced",
    "Beginner": "Beginner",
    "Intermediate": "Intermediate"
};

export const Stage = {
    "DRAFT": "DRAFT",
    "PUBLISHED": "PUBLISHED"
};

export const SystemDateTimeFieldVariation = {
    "BASE": "BASE",
    "COMBINED": "COMBINED",
    "LOCALIZATION": "LOCALIZATION"
};

export const TagOrderByInput = {
    "createdAt_ASC": "createdAt_ASC",
    "createdAt_DESC": "createdAt_DESC",
    "id_ASC": "id_ASC",
    "id_DESC": "id_DESC",
    "publishedAt_ASC": "publishedAt_ASC",
    "publishedAt_DESC": "publishedAt_DESC",
    "slug_ASC": "slug_ASC",
    "slug_DESC": "slug_DESC",
    "tag_ASC": "tag_ASC",
    "tag_DESC": "tag_DESC",
    "updatedAt_ASC": "updatedAt_ASC",
    "updatedAt_DESC": "updatedAt_DESC"
};

export const TeachersInfoCardOrderByInput = {
    "description_ASC": "description_ASC",
    "description_DESC": "description_DESC",
    "id_ASC": "id_ASC",
    "id_DESC": "id_DESC",
    "title_ASC": "title_ASC",
    "title_DESC": "title_DESC"
};

export const TestimonialOrderByInput = {
    "authorLink_ASC": "authorLink_ASC",
    "authorLink_DESC": "authorLink_DESC",
    "author_ASC": "author_ASC",
    "author_DESC": "author_DESC",
    "createdAt_ASC": "createdAt_ASC",
    "createdAt_DESC": "createdAt_DESC",
    "generic_ASC": "generic_ASC",
    "generic_DESC": "generic_DESC",
    "id_ASC": "id_ASC",
    "id_DESC": "id_DESC",
    "publishedAt_ASC": "publishedAt_ASC",
    "publishedAt_DESC": "publishedAt_DESC",
    "testimonial_ASC": "testimonial_ASC",
    "testimonial_DESC": "testimonial_DESC",
    "updatedAt_ASC": "updatedAt_ASC",
    "updatedAt_DESC": "updatedAt_DESC"
};

export const UsecasemarketingPageOrderByInput = {
    "createdAt_ASC": "createdAt_ASC",
    "createdAt_DESC": "createdAt_DESC",
    "id_ASC": "id_ASC",
    "id_DESC": "id_DESC",
    "publishedAt_ASC": "publishedAt_ASC",
    "publishedAt_DESC": "publishedAt_DESC",
    "updatedAt_ASC": "updatedAt_ASC",
    "updatedAt_DESC": "updatedAt_DESC"
};

export const UserKind = {
    "MEMBER": "MEMBER",
    "PAT": "PAT",
    "PUBLIC": "PUBLIC",
    "WEBHOOK": "WEBHOOK"
};

export const UserOrderByInput = {
    "createdAt_ASC": "createdAt_ASC",
    "createdAt_DESC": "createdAt_DESC",
    "id_ASC": "id_ASC",
    "id_DESC": "id_DESC",
    "isActive_ASC": "isActive_ASC",
    "isActive_DESC": "isActive_DESC",
    "kind_ASC": "kind_ASC",
    "kind_DESC": "kind_DESC",
    "name_ASC": "name_ASC",
    "name_DESC": "name_DESC",
    "picture_ASC": "picture_ASC",
    "picture_DESC": "picture_DESC",
    "publishedAt_ASC": "publishedAt_ASC",
    "publishedAt_DESC": "publishedAt_DESC",
    "updatedAt_ASC": "updatedAt_ASC",
    "updatedAt_DESC": "updatedAt_DESC"
};

export const VideoListOrderByInput = {
    "id_ASC": "id_ASC",
    "id_DESC": "id_DESC"
};

export const YoutubeVideoOrderByInput = {
    "advanceSeconds_ASC": "advanceSeconds_ASC",
    "advanceSeconds_DESC": "advanceSeconds_DESC",
    "createdAt_ASC": "createdAt_ASC",
    "createdAt_DESC": "createdAt_DESC",
    "id_ASC": "id_ASC",
    "id_DESC": "id_DESC",
    "name_ASC": "name_ASC",
    "name_DESC": "name_DESC",
    "publishedAt_ASC": "publishedAt_ASC",
    "publishedAt_DESC": "publishedAt_DESC",
    "updatedAt_ASC": "updatedAt_ASC",
    "updatedAt_DESC": "updatedAt_DESC",
    "youtubeVideoId_ASC": "youtubeVideoId_ASC",
    "youtubeVideoId_DESC": "youtubeVideoId_DESC"
};

export const _FilterKind = {
    "AND": "AND",
    "NOT": "NOT",
    "OR": "OR",
    "contains": "contains",
    "contains_all": "contains_all",
    "contains_none": "contains_none",
    "contains_some": "contains_some",
    "ends_with": "ends_with",
    "eq": "eq",
    "eq_not": "eq_not",
    "gt": "gt",
    "gte": "gte",
    "in": "in",
    "json_path_exists": "json_path_exists",
    "json_value_recursive": "json_value_recursive",
    "lt": "lt",
    "lte": "lte",
    "not_contains": "not_contains",
    "not_ends_with": "not_ends_with",
    "not_in": "not_in",
    "not_starts_with": "not_starts_with",
    "relational_every": "relational_every",
    "relational_none": "relational_none",
    "relational_single": "relational_single",
    "relational_some": "relational_some",
    "search": "search",
    "starts_with": "starts_with",
    "union_empty": "union_empty",
    "union_every": "union_every",
    "union_none": "union_none",
    "union_single": "union_single",
    "union_some": "union_some"
};

export const _MutationInputFieldKind = {
    "enum": "enum",
    "relation": "relation",
    "richText": "richText",
    "richTextWithEmbeds": "richTextWithEmbeds",
    "scalar": "scalar",
    "union": "union",
    "virtual": "virtual"
};

export const _MutationKind = {
    "create": "create",
    "delete": "delete",
    "deleteMany": "deleteMany",
    "publish": "publish",
    "publishMany": "publishMany",
    "schedulePublish": "schedulePublish",
    "scheduleUnpublish": "scheduleUnpublish",
    "unpublish": "unpublish",
    "unpublishMany": "unpublishMany",
    "update": "update",
    "updateMany": "updateMany",
    "upsert": "upsert"
};

export const _OrderDirection = {
    "asc": "asc",
    "desc": "desc"
};

export const _RelationInputCardinality = {
    "many": "many",
    "one": "one"
};

export const _RelationInputKind = {
    "create": "create",
    "update": "update"
};

export const _RelationKind = {
    "regular": "regular",
    "union": "union"
};

export const _SystemDateTimeFieldVariation = {
    "base": "base",
    "combined": "combined",
    "localization": "localization"
};